//WMS - 入库管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';
export class getApprovalDetail {
    constructor() {
    }
    protected static groupUrl = '/scan/goods';
    // https://api.pre.mzdata.top/data-dist/api/dist/wms/bill/out/list
    // http://47.95.206.72:3001/mock/13/data-dist/api/dist/scan/goods/details
    //获取所有分类
    public static async getApprovalDetailList(data) {
        let uri = this.groupUrl + '/details';
        return await ServerDistApi.send(uri, data);
    }
    //新增商品列表下拉数据

    //配货管理-详情-配货明细
    public static async getApprovalDetailedList(data) {
        let uri = this.groupUrl + '/details/detailed';
        return await ServerDistApi.send(uri, data);
    }
}


